import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Col, Grid } from 'components/grid'

import * as S from './styles'

const WhistleblowingChannel: FC = memo(() => (
  <S.Section>
    <Grid col={{ phone: 1, tablet: 12 }}>
      <Col col={{ tablet: 10, desktop: 3 }} start={{ tablet: 2, desktop: 2 }}>
        <S.TitleWrapper>
          <Text as="h2" size="heading2" weight="medium" color="var(--colors-pink-text-contrast)">
            Canal{' '}
            <Text as="span" size="heading2" weight="medium" color="var(--colors-neutral-text-default)">
              de
              <br />
              Denúncias
            </Text>
          </Text>
        </S.TitleWrapper>
      </Col>

      <Col col={{ tablet: 10, desktop: 6 }} start={{ tablet: 2, desktop: 5 }}>
        <S.Questions>
          <S.Question>
            <Text as="h3" size="heading3" weight="medium" color="var(--colors-neutral-text-default)">
              O que é?
            </Text>
            <Text size="body2" color="var(--colors-neutral-text-default)">
              O Canal de Denúncias é um meio de comunicação sigiloso, independente e imparcial.
            </Text>
          </S.Question>

          <S.Question>
            <Text as="h3" size="heading3" weight="medium" color="var(--colors-neutral-text-default)">
              Quem deve usá-lo?
            </Text>
            <Text size="body2" color="var(--colors-neutral-text-default)">
              O Canal de Denúncias é destinado a todos os colaboradores e nossos estagiários, bem como aos parceiros de
              negócios, prestadores de serviço e fornecedores, sempre que perceberem um comportamento ou uma decisão que
              esteja, ou pareça estar, em desacordo com o nosso Programa de Integridade — como atos de corrupção,
              fraude, irregularidades previstas na Lei n.º 12.846/2013, além de condutas que envolvam violação de
              direitos humanos ou degradação ao meio ambiente.
            </Text>
            <Text size="body2" color="var(--colors-neutral-text-default)">
              Não tenha medo em se manifestar, pois é garantida a sua confidencialidade, ou seja, seu nome não será
              divulgado a menos que você se identifique. E a Cashme também não tolera nenhum tipo de retaliação contra o
              denunciante, ou seja, você não sofrerá nenhum tipo de perseguição ou punição por ter feito uma denúncia.
            </Text>
          </S.Question>
        </S.Questions>
      </Col>
    </Grid>
  </S.Section>
))

WhistleblowingChannel.displayName = 'WhistleblowingChannel'

export default WhistleblowingChannel
